import pathOr from 'ramda/src/pathOr';
import global from './global';
import { SortDirection } from '../types';
export const reverseSortDirection = (d) => d === SortDirection.ASC ? SortDirection.DESC : SortDirection.ASC;
export const SORT_IGNORED_VALUES = [global.NOT_AVAILABLE, null, undefined, ''];
export const genericTableSort = (a, b, sortDirection, pushValuesToEndRegardlessOfSortDirection, propPathOrFunction, ...tieBreakerPropPathsOrFunctions) => {
    const resultMultiplicationFactor = sortDirection === SortDirection.ASC ? 1 : -1;
    const areThereTieBreakerPropPaths = tieBreakerPropPathsOrFunctions.length > 0;
    let valueA, valueB;
    if (typeof propPathOrFunction === 'object') {
        valueA = pathOr(undefined, propPathOrFunction, a);
        valueB = pathOr(undefined, propPathOrFunction, b);
    }
    else if (typeof propPathOrFunction === 'function') {
        valueA = propPathOrFunction(a);
        valueB = propPathOrFunction(b);
    }
    if (pushValuesToEndRegardlessOfSortDirection.indexOf(valueA) > -1)
        return 1;
    if (pushValuesToEndRegardlessOfSortDirection.indexOf(valueB) > -1)
        return -1;
    const recursivelySortByTieBreakerPropPaths = () => {
        const nextTieBreakerPropPathOrFunction = tieBreakerPropPathsOrFunctions.shift();
        const restOfTieBreakerPropPathsOrFunctions = tieBreakerPropPathsOrFunctions;
        return genericTableSort(a, b, sortDirection, pushValuesToEndRegardlessOfSortDirection, nextTieBreakerPropPathOrFunction, ...restOfTieBreakerPropPathsOrFunctions);
    };
    if (valueA === valueB && areThereTieBreakerPropPaths) {
        return recursivelySortByTieBreakerPropPaths();
    }
    // Numeric sort
    const areValuesNumbers = (typeof valueA === 'number' && typeof valueB === 'number') ||
        (!isNaN(valueA) && !isNaN(valueB));
    if (areValuesNumbers) {
        const numericCompareValue = Number(valueA) - Number(valueB);
        if (numericCompareValue === 0 && areThereTieBreakerPropPaths) {
            return recursivelySortByTieBreakerPropPaths();
        }
        return numericCompareValue * resultMultiplicationFactor;
    }
    // String sort
    const areValuesStrings = typeof valueA === 'string' && typeof valueB === 'string';
    if (areValuesStrings) {
        const localCompareValue = valueA.localeCompare(valueB);
        if (localCompareValue === 0 && areThereTieBreakerPropPaths) {
            return recursivelySortByTieBreakerPropPaths();
        }
        return localCompareValue * resultMultiplicationFactor;
    }
    // if the two types are not comparable ????
    return 0;
};
